module.exports = __webpack_public_path__ + "static/media/logo.a563f5cd.svg";